var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoldWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85718 13.7796L0.529183 8.26362C0.316435 8.04045 0.197754 7.74395 0.197754 7.43562C0.197754 7.12729 0.316435 6.83079 0.529183 6.60762C0.632007 6.49867 0.756004 6.41186 0.893569 6.35253C1.03113 6.29321 1.17937 6.2626 1.32918 6.2626C1.479 6.2626 1.62723 6.29321 1.7648 6.35253C1.90236 6.41186 2.02636 6.49867 2.12918 6.60762L6.58618 11.2206L14.1272 0.855621C14.2136 0.733182 14.324 0.629557 14.4517 0.551017C14.5794 0.472476 14.7216 0.420654 14.8699 0.398685C15.0182 0.376716 15.1693 0.385058 15.3143 0.423205C15.4592 0.461352 15.5949 0.528512 15.7132 0.620621C15.9541 0.813113 16.1116 1.09095 16.1531 1.39649C16.1947 1.70203 16.117 2.01183 15.9362 2.26162L7.76718 13.4726C7.68908 13.5839 7.59111 13.6799 7.47818 13.7556C7.47099 13.7638 7.46331 13.7714 7.45518 13.7786C7.3521 13.887 7.22799 13.9733 7.09043 14.0321C6.95288 14.0909 6.80478 14.121 6.65518 14.1206C6.50609 14.1203 6.35858 14.0899 6.22148 14.0313C6.08437 13.9727 5.96048 13.8871 5.85718 13.7796Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoldWhiteIcon);
export default __webpack_public_path__ + "static/media/check-bold-white-icon.5ab2a81d.svg";
export { ForwardRef as ReactComponent };